export enum DeliveryTimeRangeEnum {
    D15_30_MIN = "D15_30_MIN",
    D30_45_MIN = "D30_45_MIN",
    D45_60_MIN = "D45_60_MIN"
}
